// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

const mapRegistrationHeaders = (sortBy, viewMap) => viewMap.find(item => item.value === sortBy).key;

export const sortRegistrationReports = (sortBy, sortDirection, viewMap, collection) =>
    dispatch => {

        const currentSort = [
            {
                key: mapRegistrationHeaders(sortBy, viewMap),
                order: sortDirection,
                value: sortBy
            }
        ];

        dispatch({
            collection,
            sortBy: [mapRegistrationHeaders(sortBy, viewMap)],
            sortDirection,
            type: actions.SORT_REGISTRATION_REVIEW_REPORT
        });

        dispatch({
            sortBy: currentSort,
            type: actions.UPDATE_REGISTRATIONS_REVIEW_VIEWS
        });

    };

export const resetRegistrationReports = () => ({
    type: actions.RESET_REGISTRATIONS_REVIEW_VIEWS
});



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/sort-registration-report.js